import { useCallback, useEffect, RefObject } from 'react';

interface UseFocusInputOptions {
	inputRef: RefObject<any>;
	isVisible?: boolean;
	onFocus?: () => void;
}

/**
 * Custom hook to focus an input element when it becomes visible
 * @param inputRef - Ref to the input element
 * @param isVisible - Whether the input should be focused (typically when component becomes visible)
 * @param onFocus - Optional callback to execute when focusing (e.g., clear input value)
 */
const useFocusInput = ({ inputRef, isVisible, onFocus }: UseFocusInputOptions) => {
	const focusInput = useCallback(() => {
		setTimeout(() => {
			if (inputRef.current) {
				if (inputRef.current.focus) {
					inputRef.current.focus();
					onFocus?.();
				}
			}
		}, 0);
	}, [inputRef, onFocus]);

	useEffect(() => {
		if (isVisible) {
			focusInput();
		}
	}, [isVisible, focusInput]);
};

export default useFocusInput;
